import React from 'react';
import { Button as MuiButton, alpha } from '@mui/material';

const Button = (props) => {
const defaultColor = '#FDA041';
const { bgColor = defaultColor, textColor, children, applyBoxShadow = false, size='medium', sx, ...rest } = props;


const sizeStyles = {
  small: { height: '40px', fontSize: '0.9rem', padding: '7px 12px' },
  medium: { height: '45px', fontSize: '1rem', padding: '10px 16px' }, // Default
  large: { height: '55px', fontSize: '1.25rem', padding: '12px 20px' },
};

  const sxRoot = {
    ...sizeStyles[size],
    boxShadow: applyBoxShadow ? '0px 4px 10px 0px #00000040' : 'none',
    display: 'flex',
    outline: 0,
    textTransform: 'unset',
    borderRadius: '10px', 
    fontWeight: '600',
    '&.MuiButton-contained': {
      backgroundColor: bgColor, 
      color: textColor,
      ':hover': {
        backgroundColor: alpha(bgColor, 0.8), 
        boxShadow: 'none'
      },
      '&:disabled': {
        cursor: 'default',
        PointerEvent: 'none',
        color: alpha(bgColor, 0.6), 
        backgroundColor: alpha(bgColor, 0.3), 
      },
    },
    '&.MuiButton-outlined': {
      color: textColor || 'var(--black)',
      backgroundColor: 'var(--white)',
      borderColor: 'var(--gray-300)',
      ':hover': {
        // backgroundColor: alpha(bgColor, 0.15),
        // borderColor: alpha(bgColor, 0.8),
        backgroundColor: 'var(--gray-50)',
        borderColor: 'var(--gray-300)',

      },
      '&:disabled': {
        cursor: 'default',
        PointerEvent: 'none',
        color: 'var(--gray-50)',
        backgroundColor: bgColor ?? 'var(--gray-200)',
        borderColor: 'var(--gray-200)',
        '&:active': {
          backgroundColor: alpha(bgColor, 0.3),
          border: `solid 1px var(--gray-200)`,
        },
      },
    },
    '&.MuiButton-text': {
      color: bgColor,
      ':hover': {
        backgroundColor: alpha(bgColor, 0.15),
      },
      '&:disabled': {
        cursor: 'default',
        PointerEvent: 'none',
        color: 'var(--gray-200)',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        '&:active': {
          backgroundColor: alpha(bgColor, 0.3),
        },
      },
    },
    ...sx,
  };

  return (
    <MuiButton sx={sxRoot} {...rest}>
      {children}
    </MuiButton>
  );
};

export default Button;
